import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "honorarios" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "filters" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "toggle-filter" }
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { class: "installment-summary" }
const _hoisted_10 = {
  key: 0,
  class: "installment-meta overdue"
}
const _hoisted_11 = { class: "actions-cell" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick", "title"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "details-row"
}
const _hoisted_17 = { colspan: "9" }
const _hoisted_18 = { class: "details-panel" }
const _hoisted_19 = { class: "details-summary" }
const _hoisted_20 = { class: "mini-card" }
const _hoisted_21 = { class: "mini-card" }
const _hoisted_22 = { class: "mini-card" }
const _hoisted_23 = {
  key: 0,
  class: "mini-card warning"
}
const _hoisted_24 = { class: "installments-grid" }
const _hoisted_25 = { class: "installment-head" }
const _hoisted_26 = { class: "installment-title" }
const _hoisted_27 = { class: "installment-date" }
const _hoisted_28 = { class: "installment-values" }
const _hoisted_29 = {
  key: 0,
  class: "installment-warning"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 0,
  class: "modal"
}
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "autocomplete-container" }
const _hoisted_37 = {
  key: 0,
  class: "suggestions"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = ["value", "disabled"]
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = ["value", "disabled"]
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = ["value", "disabled"]
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 0,
  class: "form-group"
}
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 0,
  value: "Pendente"
}
const _hoisted_57 = {
  key: 1,
  value: "Recebido"
}
const _hoisted_58 = {
  key: 0,
  class: "field-help"
}
const _hoisted_59 = {
  key: 1,
  class: "field-help"
}
const _hoisted_60 = { class: "form-actions" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { class: "modal-content notice-modal" }
const _hoisted_63 = { class: "modal-actions" }
const _hoisted_64 = { class: "modal-content notice-modal" }
const _hoisted_65 = { class: "modal-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationControls = _resolveComponent("PaginationControls")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[26] || (_cache[26] = _createElementVNode("h1", null, null, -1)),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true)),
        class: "btn btn-success"
      }, [...(_cache[25] || (_cache[25] = [
        _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
        _createTextVNode(" Novo Honorario ", -1)
      ]))])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[28] || (_cache[28] = _createElementVNode("label", { for: "filtroStatus" }, "Filtrar por Status:", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "filtroStatus",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filtroStatus) = $event))
        }, [...(_cache[27] || (_cache[27] = [
          _createElementVNode("option", { value: "" }, "Todos", -1),
          _createElementVNode("option", { value: "Pendente" }, "Pendente", -1),
          _createElementVNode("option", { value: "Recebido" }, "Recebido", -1)
        ]))], 512), [
          [_vModelSelect, _ctx.filtroStatus]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[30] || (_cache[30] = _createElementVNode("label", { for: "filtroArea" }, "�rea Juridica:", -1)),
        _withDirectives(_createElementVNode("select", {
          id: "filtroArea",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filtroArea) = $event))
        }, [...(_cache[29] || (_cache[29] = [
          _createStaticVNode("<option value=\"\" data-v-a238c468>Todas</option><option value=\"Civil\" data-v-a238c468>Civil</option><option value=\"Trabalhista\" data-v-a238c468>Trabalhista</option><option value=\"Criminal\" data-v-a238c468>Criminal</option><option value=\"Empresarial\" data-v-a238c468>Empresarial</option><option value=\"Fam�lia\" data-v-a238c468>Familia</option><option value=\"Tribut�rio\" data-v-a238c468>Tributario</option>", 7)
        ]))], 512), [
          [_vModelSelect, _ctx.filtroArea]
        ])
      ]),
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.somenteAtrasados) = $event)),
          type: "checkbox"
        }, null, 512), [
          [_vModelCheckbox, _ctx.somenteAtrasados]
        ]),
        _cache[31] || (_cache[31] = _createElementVNode("span", null, "Somente com parcelas em atraso", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("table", _hoisted_8, [
        _cache[44] || (_cache[44] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Cliente"),
            _createElementVNode("th", null, "N� Processo"),
            _createElementVNode("th", null, "�rea Juridica"),
            _createElementVNode("th", null, "Valor Total"),
            _createElementVNode("th", null, "Recebido"),
            _createElementVNode("th", null, "Parcelas"),
            _createElementVNode("th", null, "Proximo Vencimento"),
            _createElementVNode("th", null, "Status"),
            _createElementVNode("th", null, "A��es")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.honorariosPaginados, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.honorario.id
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(item.customerName), 1),
                _createElementVNode("td", null, _toDisplayString(item.honorario.processNumber), 1),
                _createElementVNode("td", null, _toDisplayString(item.honorario.legalArea), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(item.honorario.value)), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(item.honorario.paidValue)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("strong", null, _toDisplayString(item.installmentText), 1),
                    (item.overdueCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item.overdueCount) + " em atraso ", 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", null, _toDisplayString(item.nextPendingLabel), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['status-badge', item.summary.status.toLowerCase()])
                  }, _toDisplayString(item.summary.status), 3)
                ]),
                _createElementVNode("td", _hoisted_11, [
                  (item.summary.status === 'Pendente')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.marcarHonorarioComoRecebido(item)),
                        class: "btn-action paid",
                        title: "Marcar tudo como Recebido"
                      }, [...(_cache[32] || (_cache[32] = [
                        _createElementVNode("i", { class: "fas fa-check" }, null, -1)
                      ]))], 8, _hoisted_12))
                    : _createCommentVNode("", true),
                  (item.summary.status === 'Recebido')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.marcarHonorarioComoPendente(item)),
                        class: "btn-action pending",
                        title: "Marcar tudo como Pendente"
                      }, [...(_cache[33] || (_cache[33] = [
                        _createElementVNode("i", { class: "fas fa-undo" }, null, -1)
                      ]))], 8, _hoisted_13))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.toggleParcelas(item.honorario.id)),
                    class: "btn-action info",
                    title: _ctx.isExpanded(item.honorario.id) ? 'Ocultar parcelas' : 'Ver parcelas'
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.isExpanded(item.honorario.id) ? 'fas fa-chevron-up' : 'fas fa-chevron-down')
                    }, null, 2)
                  ], 8, _hoisted_14),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.abrirDeleteModal(item.honorario.id)),
                    class: "btn-action delete",
                    title: "Deletar"
                  }, [...(_cache[34] || (_cache[34] = [
                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                  ]))], 8, _hoisted_15)
                ])
              ]),
              (_ctx.isExpanded(item.honorario.id))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("article", _hoisted_20, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", null, "Total", -1)),
                            _createElementVNode("strong", null, _toDisplayString(item.installments.length) + " parcela(s)", 1)
                          ]),
                          _createElementVNode("article", _hoisted_21, [
                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "Pagas", -1)),
                            _createElementVNode("strong", null, _toDisplayString(item.summary.paidCount), 1)
                          ]),
                          _createElementVNode("article", _hoisted_22, [
                            _cache[37] || (_cache[37] = _createElementVNode("span", null, "Pendentes", -1)),
                            _createElementVNode("strong", null, _toDisplayString(item.summary.pendingCount), 1)
                          ]),
                          (item.overdueCount > 0)
                            ? (_openBlock(), _createElementBlock("article", _hoisted_23, [
                                _cache[38] || (_cache[38] = _createElementVNode("span", null, "Em atraso", -1)),
                                _createElementVNode("strong", null, _toDisplayString(item.overdueCount), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.installments, (installment) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: installment.id,
                              class: _normalizeClass(["installment-card", { paid: installment.status === 'Recebido', overdue: installment.isOverdue }])
                            }, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_26, "Parcela " + _toDisplayString(installment.label), 1),
                                  _createElementVNode("p", _hoisted_27, "Vencimento " + _toDisplayString(installment.dueDateLabel), 1)
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass(['status-badge', installment.status.toLowerCase()])
                                }, _toDisplayString(installment.status), 3)
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", null, [
                                  _cache[39] || (_cache[39] = _createElementVNode("span", null, "Valor", -1)),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(installment.value)), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[40] || (_cache[40] = _createElementVNode("span", null, "Recebido", -1)),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(installment.paidValue)), 1)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[41] || (_cache[41] = _createElementVNode("span", null, "A receber", -1)),
                                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(Math.max(installment.value - installment.paidValue, 0))), 1)
                                ])
                              ]),
                              (installment.isOverdue)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, " Parcela vencida e ainda pendente. "))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["btn", installment.status === 'Recebido' ? 'btn-secondary' : 'btn-success']),
                                onClick: ($event: any) => (_ctx.alternarParcela(item, installment.installmentNumber))
                              }, _toDisplayString(installment.status === 'Recebido' ? 'Reabrir parcela' : 'Dar baixa na parcela'), 11, _hoisted_30)
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_ctx.honorariosFiltrados.length === 0 && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [...(_cache[42] || (_cache[42] = [
                _createElementVNode("td", {
                  colspan: "9",
                  class: "no-data"
                }, "Nenhum honorario encontrado", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_32, [...(_cache[43] || (_cache[43] = [
                _createElementVNode("td", {
                  colspan: "9",
                  class: "no-data"
                }, "Carregando...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_PaginationControls, {
      "current-page": _ctx.paginaAtual,
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paginaAtual) = $event)),
      "items-per-page": _ctx.itensPorPagina,
      "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.itensPorPagina) = $event)),
      "total-items": _ctx.honorariosFiltrados.length,
      "total-pages": _ctx.totalPaginas,
      disabled: _ctx.loading
    }, null, 8, ["current-page", "items-per-page", "total-items", "total-pages", "disabled"]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _cache[58] || (_cache[58] = _createElementVNode("h2", null, "Cadastrar Novo Honorario", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.salvarHonorario && _ctx.salvarHonorario(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_35, [
                _cache[45] || (_cache[45] = _createElementVNode("label", { for: "cliente" }, "Cliente *", -1)),
                _createElementVNode("div", _hoisted_36, [
                  _withDirectives(_createElementVNode("input", {
                    id: "cliente",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.buscarCliente) = $event)),
                    type: "text",
                    onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleClienteInput && _ctx.handleClienteInput(...args))),
                    onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mostrarSugestoes = true)),
                    placeholder: "Digite o nome do cliente...",
                    required: ""
                  }, null, 544), [
                    [_vModelText, _ctx.buscarCliente]
                  ]),
                  (_ctx.mostrarSugestoes && _ctx.clientesFiltrados.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientesFiltrados, (cliente) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: cliente.id,
                            onClick: ($event: any) => (_ctx.selecionarCliente(cliente)),
                            class: "suggestion-item"
                          }, _toDisplayString(cliente.fullName), 9, _hoisted_38))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[46] || (_cache[46] = _createElementVNode("label", { for: "processNumber" }, "Nr Processo *", -1)),
                _createElementVNode("input", {
                  id: "processNumber",
                  value: _ctx.novoHonorario.processNumber,
                  type: "text",
                  placeholder: "1234567-89.2024.8.26.0100",
                  maxlength: "25",
                  onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.formatarNumeroProcessoInput && _ctx.formatarNumeroProcessoInput(...args))),
                  disabled: !_ctx.canEditProcessNumber,
                  required: ""
                }, null, 40, _hoisted_40)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _cache[48] || (_cache[48] = _createElementVNode("label", { for: "legalArea" }, "Area Juridica *", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "legalArea",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.novoHonorario.legalArea) = $event)),
                  disabled: !_ctx.canEditLegalArea,
                  required: ""
                }, [...(_cache[47] || (_cache[47] = [
                  _createStaticVNode("<option disabled value=\"\" data-v-a238c468>Selecione</option><option value=\"Civil\" data-v-a238c468>Civil</option><option value=\"Trabalhista\" data-v-a238c468>Trabalhista</option><option value=\"Criminal\" data-v-a238c468>Criminal</option><option value=\"Empresarial\" data-v-a238c468>Empresarial</option><option value=\"Fam�lia\" data-v-a238c468>Familia</option><option value=\"Tribut�rio\" data-v-a238c468>Tributario</option>", 7)
                ]))], 8, _hoisted_42), [
                  [_vModelSelect, _ctx.novoHonorario.legalArea]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _cache[49] || (_cache[49] = _createElementVNode("label", { for: "valor" }, "Valor (R$) *", -1)),
                _createElementVNode("input", {
                  id: "valor",
                  value: _ctx.valorFormatado,
                  type: "text",
                  inputmode: "decimal",
                  placeholder: "R$ 0,00",
                  onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.formatarValorInput && _ctx.formatarValorInput(...args))),
                  disabled: !_ctx.canEditValue,
                  required: ""
                }, null, 40, _hoisted_44)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _cache[50] || (_cache[50] = _createElementVNode("label", { for: "paidValue" }, "Valor Pago (R$)", -1)),
                _createElementVNode("input", {
                  id: "paidValue",
                  value: _ctx.valorPagoFormatado,
                  type: "text",
                  inputmode: "decimal",
                  placeholder: "R$ 0,00",
                  onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.formatarValorPagoInput && _ctx.formatarValorPagoInput(...args))),
                  disabled: !_ctx.canEditPaidValue
                }, null, 40, _hoisted_46)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _cache[51] || (_cache[51] = _createElementVNode("label", { for: "date" }, "Data Base *", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "date",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.novoHonorario.date) = $event)),
                  type: "date",
                  disabled: !_ctx.canEditDate,
                  required: ""
                }, null, 8, _hoisted_48), [
                  [_vModelText, _ctx.novoHonorario.date]
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _cache[53] || (_cache[53] = _createElementVNode("label", { for: "paymentMethod" }, "Forma de Pagamento *", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "paymentMethod",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.novoHonorario.paymentMethod) = $event)),
                  onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.ajustarParcelas && _ctx.ajustarParcelas(...args))),
                  disabled: !_ctx.canEditPaymentMethod,
                  required: ""
                }, [...(_cache[52] || (_cache[52] = [
                  _createStaticVNode("<option disabled value=\"\" data-v-a238c468>Selecione</option><option value=\"Dinheiro\" data-v-a238c468>Dinheiro</option><option value=\"Pix\" data-v-a238c468>Pix</option><option value=\"D�bito\" data-v-a238c468>Debito</option><option value=\"Cr�dito\" data-v-a238c468>Credito</option>", 5)
                ]))], 40, _hoisted_50), [
                  [_vModelSelect, _ctx.novoHonorario.paymentMethod]
                ])
              ]),
              (_ctx.isCreditSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _cache[54] || (_cache[54] = _createElementVNode("label", { for: "installments" }, "Parcelas", -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "installments",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.novoHonorario.installments) = $event)),
                      disabled: !_ctx.canEditInstallments
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcelasDisponiveis, (parcela) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: parcela,
                          value: parcela
                        }, _toDisplayString(parcela) + "x ", 9, _hoisted_53))
                      }), 128))
                    ], 8, _hoisted_52), [
                      [
                        _vModelSelect,
                        _ctx.novoHonorario.installments,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_54, [
                _cache[55] || (_cache[55] = _createElementVNode("label", { for: "status" }, "Status *", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "status",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.novoHonorario.status) = $event)),
                  disabled: _ctx.isStatusLocked || !_ctx.canEditStatus,
                  required: ""
                }, [
                  (!_ctx.isImmediatePayment)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_56, "Pendente"))
                    : _createCommentVNode("", true),
                  (!_ctx.isCreditSelected)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_57, "Recebido"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_55), [
                  [_vModelSelect, _ctx.novoHonorario.status]
                ]),
                (_ctx.isCreditSelected)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_58, " Honorarios em Credito devem iniciar como pendentes para permitir o controle das parcelas. "))
                  : (_ctx.isImmediatePayment)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_59, " Pagamentos em Pix e Debito entram direto como recebidos. "))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-success",
                  disabled: !_ctx.formularioCompleto
                }, [...(_cache[56] || (_cache[56] = [
                  _createElementVNode("i", { class: "fas fa-save" }, null, -1),
                  _createTextVNode(" Salvar ", -1)
                ]))], 8, _hoisted_61),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cancelar && _ctx.cancelar(...args)))
                }, [...(_cache[57] || (_cache[57] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1),
                  _createTextVNode(" Cancelar ", -1)
                ]))])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal",
          onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fecharDeleteModal && _ctx.fecharDeleteModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_62, [
            _cache[59] || (_cache[59] = _createElementVNode("h2", null, "Confirmar exclusao", -1)),
            _cache[60] || (_cache[60] = _createElementVNode("p", null, "Tem certeza que deseja deletar este honorario?", -1)),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.fecharDeleteModal && _ctx.fecharDeleteModal(...args)))
              }, " Cancelar "),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.confirmarDeleteHonorario && _ctx.confirmarDeleteHonorario(...args)))
              }, " Deletar ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showNoticeModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal",
          onClick: _cache[24] || (_cache[24] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fecharNoticeModal && _ctx.fecharNoticeModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_64, [
            _cache[61] || (_cache[61] = _createElementVNode("h2", null, "Aviso", -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.noticeMessage), 1),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.fecharNoticeModal && _ctx.fecharNoticeModal(...args)))
              }, " Fechar ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}